import * as React from "react";

function SvgTwitter2(props) {
  return (
    <svg width={30} height={30} fill="none" viewBox="0 0 30 30" {...props}>
      <g clipPath="url(#twitter2_svg__clip0)">
        <path
          fill="#1DA1F2"
          d="M30 5.69631C28.8962 6.18631 27.71 6.51631 26.465 6.66506C27.7363 5.90381 28.7125 4.69756 29.1712 3.26006C27.9825 3.96506 26.665 4.47756 25.2625 4.75381C24.1412 3.55756 22.54 2.81006 20.77 2.81006C16.7962 2.81006 13.8763 6.51756 14.7738 10.3663C9.66 10.1101 5.125 7.66006 2.08875 3.93631C0.47625 6.70256 1.2525 10.3213 3.9925 12.1538C2.985 12.1213 2.035 11.8451 1.20625 11.3838C1.13875 14.2351 3.1825 16.9026 6.1425 17.4963C5.27625 17.7313 4.3275 17.7863 3.3625 17.6013C4.145 20.0463 6.4175 21.8251 9.1125 21.8751C6.525 23.9038 3.265 24.8101 0 24.4251C2.72375 26.1713 5.96 27.1901 9.435 27.1901C20.8625 27.1901 27.3187 17.5388 26.9287 8.88256C28.1312 8.01381 29.175 6.93006 30 5.69631Z"
        />
      </g>
      <defs>
        <clipPath id="twitter2_svg__clip0">
          <path fill="#fff" d="M0 0H30V30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgTwitter2;
